import { render, staticRenderFns } from "./noticeManage.vue?vue&type=template&id=ec35e558&scoped=true&"
import script from "./noticeManage.vue?vue&type=script&lang=ts&"
export * from "./noticeManage.vue?vue&type=script&lang=ts&"
import style0 from "./noticeManage.vue?vue&type=style&index=0&id=ec35e558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec35e558",
  null
  
)

export default component.exports